<template>
  <div
    v-if="!isGiftCard"
    class="c-product-info__price"
  >
    <product-price
      :price="price"
      :compare-at-price="previousPrice"
      :inject-sezzle="true"
      :size="'large'"
    >
      <product-price-pill
        v-if="previousPrice > price"
      >
        {{ percentOff }}%&nbsp;OFF
      </product-price-pill>
    </product-price>
  </div>
  <div
    v-else-if="isGiftCard && priceRange.min"
    class="c-product-info__price c-product-info__price--giftcard"
  >
    <span class="c-product-price">
      <span
        v-if="priceRange.max !== priceRange.min"
        class="t-heading-8 c-product-price__price"
      >
        {{ priceRange.min | currency }} - {{ priceRange.max | currency }}
      </span>
      <span
        v-else
        class="t-heading-8 c-product-price__price"
      >
        {{ priceRange.min | currency }}
      </span>
    </span>
  </div>
</template>
<script>
import get from 'lodash/get'
import ProductPrice from '../productPrice/ProductPrice'
import ProductPricePill from '../productPricePill/ProductPricePill'
import toNumber from 'lodash/toNumber'
export default {
  components: {
    ProductPricePill,
    ProductPrice
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: [String, Number],
      default: ''
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    selectedVariant: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    percentOff() {
      const product = this.product
      const previousPrice = this.previousPrice
      const price = this.price
      let result = null
      if (product) {
        result = Math.round((previousPrice - price) / previousPrice * 100)
      }
      return result
    },
    price() {
      const product = this.product
      const selectedVariant = this.selectedVariant
      const isGiftCard = this.isGiftCard
      let result = 0
      if (selectedVariant && isGiftCard) {
        result = selectedVariant.price
      } else if (product) {
        result = get(product, 'variants[0].price')
      }
      return result ? toNumber(result) : 0
    },
    previousPrice() {
      const product = this.product
      const selectedVariant = this.selectedVariant
      const isGiftCard = this.isGiftCard
      let result = 0
      if (selectedVariant && isGiftCard) {
        result = get(selectedVariant, 'price')
      } else if (product) {
        result = (
          get(product, 'variants[0].compareAtPrice') ||
          get(product, 'varients[0].price')
        )
      }
      return result ? toNumber(result) : 0
    },
    priceRange() {
      const product = this.product
      const { min, max } = get(product, 'priceRange') || {}
      return { min: toNumber(min), max: toNumber(max) }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-product-info__price {
  margin-bottom: rem(10px);
  &--giftcard {
    margin-bottom: rem(5px);
  }
}
</style>
